var map = {
	"./de/mechaName.png": "4JWp",
	"./en/mechaName.png": "iP7B",
	"./es/mechaName.png": "MzSC",
	"./fr/mechaName.png": "yvJL",
	"./ja/mechaName.png": "K66u",
	"./ko/mechaName.png": "5wjG",
	"./pt/mechaName.png": "Dz2y",
	"./ru/mechaName.png": "mGyX",
	"./tc/mechaName.png": "WZnf",
	"./th/mechaName.png": "1oIx"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "r1je";